"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".adsContainer{position:relative;display:flex;justify-content:center;width:100%;padding:24px 0;z-index:1}.adsContainer__vertical{display:flex;align-items:center}.adsContainer__vertical--left{left:0}.adsContainer__vertical--right{right:0}.isVertical{display:inline-block;height:600px}.mobile-wrap .adsContainer{display:flex;justify-content:center;max-height:100px;margin:10px 0 15px;padding:0}.adsContainer.mt0{margin-top:0!important}"];
exports.styles = styles;
